// import React from 'react'

import Button from '../../button/button'

import { VscLayoutSidebarLeft, VscLayoutSidebarLeftOff, VscLayoutPanel, VscLayoutPanelOff, VscMenu } from 'react-icons/vsc'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { appConfig } from '../../../config'
import { useTranslation } from 'react-i18next'
import { GiSolarSystem  } from "react-icons/gi";

import './topNav.scss'

type TopNavPorps = {
  explorerSize: number,
  setExplorerSize: (explorerSize: number) => void,
  footerSize: number,
  setFooterSize: (footerSize: number) => void
}

function TopNav(props: Readonly<TopNavPorps>) {
  const { t } = useTranslation()
  const isMobile = window.innerWidth <= 600
  const [lastExplorerSize, setLastExplorerSize] = useState(props.explorerSize)
  const [lastFooterSize, setLastFooterSize] = useState(isMobile ? 60 : props.footerSize)
  const location = useLocation()
  const navigate = useNavigate()

  const handleExplorerOpenClose = () => {
    if(props.explorerSize > 0) {
      setLastExplorerSize(props.explorerSize)
      props.setExplorerSize(0)
    } else {
      props.setExplorerSize(lastExplorerSize)
    }
  }

  const handleFooterOpenClose = () => {
    const isMobile = window.innerWidth <= 600
    if(props.footerSize > 0) {
      setLastFooterSize(props.footerSize)
      props.setFooterSize(0)
    } else {
      const targetSize = isMobile ? Math.min(lastFooterSize, 60) : lastFooterSize
      props.setFooterSize(targetSize)
    }
  }

  return (
    <div className='comp-topNav'>
      
      <div className='topNav-main topNav-mainDesk'>
        <GiSolarSystem className='main-icon' />
        <Button
          title={'File'}
          click={() => {}}
          dropdown={appConfig.filter(conf => conf.showInNav !== false).map((conf) => ({
            title: t('navLeft.' + conf.title),
            onClick: () => navigate(conf.path)
          }))}
        />
        <Button title={'Edit'} click={() => {}} dropdown={[]} disabled={true}/>
        <Button title={'Selection'} click={() => {}} dropdown={[]} disabled={true}/>
        <Button title={'View'} click={() => navigate('/gallery')} disabled={false}/>
      </div>    
      
      <div className='topNav-main topNav-mainMobile'>
        <GiSolarSystem className='main-icon' />
        <Button
          icon={<VscMenu />}
          click={() => {}}
          dropdown={appConfig.filter(conf => conf.showInNav !== false).map((conf) => ({
            title: t('navLeft.' + conf.title),
            onClick: () => navigate(conf.path)
          }))}
          dropdownPosition='fullWidth'
          dropdownSize='large'
        />
      </div>

      <div className='topNav-mid'>
        <div className='mid-title'>
          {(() => {
            const currentConf = appConfig.find((conf) => location.pathname === conf.path)
            return currentConf ? t('navLeft.' + currentConf.title) : 'error'
          })()}
        </div>
      </div>

      <div className='topNav-second'>
        <Button
          icon={props.explorerSize > 0 ? <VscLayoutSidebarLeft /> : <VscLayoutSidebarLeftOff />}
          click={handleExplorerOpenClose}
        />
        <Button
          icon={props.footerSize > 0 ? <VscLayoutPanel /> : <VscLayoutPanelOff />}
          click={handleFooterOpenClose}
        />
      </div>
    </div>
  )
}

export default TopNav
